import { ICON_TEXT_TEXT_CLASSNAME } from '@vfde-brix/ws10/icon-text';
import { HEADLINE_BASE_CLASSNAME } from '@vfde-brix/ws10/headline';
import { Accordion } from '@vfde-brix/ws10/accordion';
import { getFiberObjectProperty } from '../util/cms';
import { AppHtmlId, DiscountHtmlId } from '../enums/elementId';
import { trackFootnoteLink } from '../util/tracking';
import { FOOTNOTE_SELECTOR } from '../constants';
import { closeAccordionItems } from './accordion';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { PreMarketingType } from '../enums/product';
import { OFFER_SUMMARY_CARD_HEADLINE_CLASSNAME,
    OFFER_SUMMARY_CARD_LEGAL_TEXT_CLASSNAME } from '@vfde-brix/ws10/offer-summary-card';
import { showElement } from '../util/visibility';
import { toggleElementVisibilityById } from '@vfde-brix/ws10/core';
const FOOTNOTE_LINK_STYLE_CLASSNAME = 'ws10-footnote-link-style';

const addOnClickEvent = (linkEl: HTMLElement, footnoteNumber: number) => {
    const footnoteItemIndex = footnoteNumber - 1;
    const footnoteAccordion: Accordion = getFiberObjectProperty(AppHtmlId.DYNAMIC_FOOTNOTE);
    const { items } = footnoteAccordion?.getProperties() || {};
    const currentItem = items?.[footnoteItemIndex];
    const footnoteEl = footnoteAccordion.getContainerElement() as HTMLElement;

    if (!currentItem || !footnoteEl) {
        return;
    }

    linkEl.onclick = () => {
        // close all items first as jumping is broken if the accordion is already opened
        closeAccordionItems(footnoteAccordion);

        footnoteAccordion.toggleItemById(currentItem.stdId);
        trackFootnoteLink(linkEl.innerText.slice(0, -1));
    };
};

const mountFootnoteLink = (element: HTMLElement, footnoteNumber: number) => {
    if (element.getElementsByClassName(FOOTNOTE_LINK_STYLE_CLASSNAME).length) {
        addOnClickEvent(element, footnoteNumber);
        return;
    }

    element.innerHTML = `${element.innerHTML}` +
        `<sup class="${FOOTNOTE_LINK_STYLE_CLASSNAME}">${footnoteNumber}</sup>`;

    addOnClickEvent(element, footnoteNumber);
};

const removeFootnoteLink = (element: HTMLElement) => {
    const footnote = element.querySelector(FOOTNOTE_SELECTOR);
    footnote && footnote.remove();
};

export const mountFootnoteLinks = (
    tariffs?: JarvisProduct[],
    fiberAvailable?: boolean,
    preMarketingType?: PreMarketingType,
    fnf?: boolean,
) => {
    // Footnote link 1: GigaKombi
    const iconTextEl = document.getElementById(DiscountHtmlId.GIGAKOMBI_ICON_TEXT);
    const [ textEl ] = iconTextEl?.getElementsByClassName(ICON_TEXT_TEXT_CLASSNAME) || [];
    textEl && mountFootnoteLink(textEl.firstElementChild as HTMLElement, 1);

    // Footnote link 2: Selected tariff
    const summaryCardEl = document.getElementById(AppHtmlId.SUMMARY_CARD);
    const [ headlineEl ] = summaryCardEl?.getElementsByClassName(OFFER_SUMMARY_CARD_HEADLINE_CLASSNAME) || [];
    const [ headEl ] = headlineEl?.getElementsByClassName(HEADLINE_BASE_CLASSNAME) || [];

    /**
     * Note: don't mount footnote link number 2 if no tariffs- or no fiber are available,
     * or if any pre marketing tariff is available
     */
    if (!tariffs?.length || false === fiberAvailable || preMarketingType) {
        headlineEl && removeFootnoteLink(headlineEl as HTMLElement);
        return;
    }

    headEl && mountFootnoteLink(headEl as HTMLElement, 2);

    // Footnote link 3: fnf footnote
    if (fnf){
        const summaryCard = document.getElementById(AppHtmlId.SUMMARY_CARD);
        const [ legalText ] = summaryCard?.getElementsByClassName(OFFER_SUMMARY_CARD_LEGAL_TEXT_CLASSNAME)
        || [];
        showElement('ws10-accordion-item-details-footnote-3', true);
        legalText && mountFootnoteLink(legalText?.lastChild as HTMLElement, 3);
        toggleElementVisibilityById(AppHtmlId.FNF_ACCORDION, fnf);
    }
};
